<template>
  <v-dialog :value="loadingStatus" persistent max-width="233px">
    <v-row class="white loading__modal">
      <v-col cols="12" class="pt-8 pb-7 d-flex justify-center">
        <v-img src="@/assets/loading.svg" max-width="66px" />
      </v-col>
      <v-col cols="12" class="text-center">
        <p class="primary--text loading__text mb-0 pb-5">
          Carregando
        </p>
      </v-col>
    </v-row>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "LoadingModal",
  computed: {
    ...mapState(["loadingStatus"])
  }
};
</script>
<style lang="sass">
.loading__
  &text
    font-weight: 700
    font-size: 20px
  &modal
    border-radius: 15px
</style>
